import React, { Suspense, PureComponent, lazy } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BQ_CLICKED_REPORT_GIG } from '../../../../utils/bigQueryEvents';

const ReportGig = lazy(() => import(/* webpackChunkName: 'ReportGig' */'..'));

class ReportBtn extends PureComponent {

    constructor() {
        super();

        // we need this to delay the render of the ReportGig component on the server side (SSR doesn't support
        // lazy loading), so we have to use this hack
        // we will set this flag to true on componentDidMount
        this.state = {
            renderReportGig: false
        };

        this.setOpenModalHandle = this.setOpenModalHandle.bind(this);
        this.onReportBtnClick = this.onReportBtnClick.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            renderReportGig: true
        });
    }

    onReportBtnClick(e) {
        e.preventDefault();

        const { biEvents } = this.context;
        biEvents.sendBigQueryEvent({eventName: BQ_CLICKED_REPORT_GIG});

        this.openModal();
    }

    setOpenModalHandle(open) {
        this.openModal = open;
    }

    render() {
        const btnClassNames = classNames('btn-standard', 'report-gig-btn');
        const {isTrustedUser} = this.props;
        const {renderReportGig} = this.state;

        return (
            <>
                <a href="#!" className={btnClassNames}
                    onClick={this.onReportBtnClick}>
                    <i className="fa fa-flag"/>
                </a>
                {
                    renderReportGig &&
                    <Suspense fallback={<div/>}>
                        <ReportGig trigger={this.setOpenModalHandle} isTrustedUser={isTrustedUser}/>
                    </Suspense>
                }
            </>
        );
    }
}

ReportBtn.propTypes = {
    isTrustedUser: PropTypes.bool
};

ReportBtn.defaultProps = {
    isTrustedUser: false
};

ReportBtn.contextTypes = {
    biEvents: PropTypes.object
};

export default ReportBtn;
